module.exports = __webpack_public_path__ + "static/media/warn-icon-16.fb2b3ad3.svg";